import {AfterViewInit, Component, OnInit} from '@angular/core';
import {BaseComponent} from 'src/app/base/base.component';
import {TranslateService} from "@ngx-translate/core";
import {NgxSpinnerService} from "ngx-spinner";
import {Router} from "@angular/router";
import {
    Country,
    GetUnitiesGQL,
    ListSectorGQL,
    MedicalCertificateByDayDashboardDto,
    MedicalCertificateByDayDashboardGQL,
    MedicalCertificateByMonthDashboardDto,
    MedicalCertificateByMonthDashboardGQL, MedicalCertificateTopCidDashboardDto, MedicalCertificateTopCidDashboardGQL,
    MedicalCertificateTotalsDashboardGQL,
    MedicalCertificateTotalsDto,
    SearchDashboardInput,
    SearchMedicalCertificateInput,
    Sector,
    Unity
} from "../../../generated/graphql";
import moment from "moment/moment";
import {ChartType} from "angular-google-charts";

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends BaseComponent implements OnInit, AfterViewInit{

    columnChart = {
        type: 'ColumnChart' as ChartType,
        data: [],
        columnNames: [
            'Mês',
            'Atestado médico',
            'Consulta/Exame',
            'Doação',
            'Acompanhante',
            'Maternidade'
        ],
        options: {
            legend: {position: 'bottom'},
            colors: ['#173c76', '#4f555b', '#6a7594', '#1f3f96', '#f0d400'],
            backgroundColor: 'transparent',
            chartArea: {
                width: '75%',
                height: '70%'
            },
            hAxis: {
                textStyle: {color: '#123b73'}
            },
            vAxis: {
                minValue: 0,
                gridlines: {color: '#d9d9d9'}
            }
        },
        width: 900,
        height: 300
    };

    lineChart = {
        type: 'LineChart' as ChartType,
        data: [],
        columnNames: [
            'Dia',
            'Atestado médico',
            'Consulta/Exame',
            'Doação',
            'Acompanhante',
            'Maternidade'
        ],
        options: {
            legend: {position: 'right'},
            backgroundColor: 'transparent',
            chartArea: {
                width: '65%',
                height: '70%'
            },
            curveType: 'function',
            pointSize: 4,
            lineWidth: 2,
            colors: ['#173c76', '#4f555b', '#6a7594', '#1f3f96', '#f0d400'],
            hAxis: {
                textStyle: {color: '#123b73'}
            },
            vAxis: {
                minValue: 0,
                gridlines: {color: '#d9d9d9'}
            }
        },
        width: 600,
        height: 300
    };

    donutChart = {
        type: 'PieChart' as ChartType,
        data: [],
        columnNames: ['CID', 'Total'],
        options: {
            pieHole: 0.55,
            legend: {position: 'right'},
            colors: ['#f0d400', '#6a7594', '#1f3763', '#173c9a', '#4f555b', '#7d8fb3', '#2c5aa0', '#a3aed0', '#d4aa00', '#3d4f73'],
            backgroundColor: 'transparent',
            chartArea: {
                width: '85%',
                height: '80%'
            }
        },
        width: 600,
        height: 300
    };

    dropSettings: any = {
        singleSelection: false,
        idField: 'id',
        textField: 'name',
        selectAllText: 'Marcar todos',
        unSelectAllText: 'Desmarcar todos',
        itemsShowLimit: 8,
        allowSearchFilter: true
    };

    searchDashboardInput: SearchDashboardInput = new SearchDashboardInput();

    listUnities: Unity[] = [];
    selectedUnities: Unity[] = [];

    listSectors: Array<Sector> = [];
    selectedSectors: Sector[] = [];

    modelMedicalCertificateTotalsDto = new MedicalCertificateTotalsDto();
    modelMedicalCertificateByMonthDashboardDto = new MedicalCertificateByMonthDashboardDto();
    modelMedicalCertificateByDayDashboardDto = new MedicalCertificateByDayDashboardDto();
    modelMedicalCertificateTopCidDashboardDto = new MedicalCertificateTopCidDashboardDto();

    constructor(public router: Router,
                public loading: NgxSpinnerService,
                public translate: TranslateService,
                public getUnitiesGQL: GetUnitiesGQL,
                public listSectorGQL: ListSectorGQL,
                public medicalCertificateTotalsDashboardGQL: MedicalCertificateTotalsDashboardGQL,
                public medicalCertificateByMonthDashboardGQL: MedicalCertificateByMonthDashboardGQL,
                public medicalCertificateByDayDashboardGQL: MedicalCertificateByDayDashboardGQL,
                public medicalCertificateTopCidDashboardGQL: MedicalCertificateTopCidDashboardGQL,
    ) {
        super(router, loading, translate);
    }

    ngAfterViewInit(): void {
    }

    ngOnInit(): void {
        this.getListSector();
        this.getUnities();

        const start = moment().subtract(30, 'days').startOf('day');
        const end = moment().endOf('day');

        this.searchDashboardInput.start = start.utcOffset(0, true).format();
        this.searchDashboardInput.end = end.utcOffset(0, true).format();

        this.setDatePicker('picker-period', (start, end, label) => {
            this.searchDashboardInput.start = start.utcOffset(0, true).startOf('day').format();
            this.searchDashboardInput.end = end.utcOffset(0, true).endOf('day').format();
        });

        this.getSearchRoutes();
    }

    getListSector() {
        this.listSectorGQL.watch().valueChanges.subscribe(({data}) => {
            this.listSectors = data.listSector as Sector[];
        }, error => super.onError(error));
    }

    getUnities() {
        this.getUnitiesGQL.watch().valueChanges.subscribe(({data}) => {
            this.listUnities = data.getUnities as Unity[];
        }, error => super.onError(error));
    }

    getSearchRoutes(){
        this.searchDashboardInput.unityIds = this.selectedUnities?.map(item => item.id) || [];
        this.searchDashboardInput.sectors = this.selectedSectors?.map(item => item.name) || [];

        this.getMedicalCertificateTotalsDashboard();
        this.getMedicalCertificateByMonthDashboard();
        this.getMedicalCertificateByDayDashboard();
        this.getMedicalCertificateTopCidDashboard();
    }

    getMedicalCertificateTotalsDashboard() {
        this.medicalCertificateTotalsDashboardGQL.watch({input: this.searchDashboardInput}).valueChanges.subscribe(({data}) => {
            this.modelMedicalCertificateTotalsDto = data?.medicalCertificateTotalsDashboard as MedicalCertificateTotalsDto;
        }, error => super.onError(error));
    }

    getMedicalCertificateByMonthDashboard() {
        this.medicalCertificateByMonthDashboardGQL.watch({input: this.searchDashboardInput}).valueChanges.subscribe(({data}) => {
            this.modelMedicalCertificateByMonthDashboardDto = data?.medicalCertificateByMonthDashboard as MedicalCertificateByMonthDashboardDto;

            const yearSelected = this.modelMedicalCertificateByMonthDashboardDto?.years?.[0];

            if (!yearSelected?.months?.length) {
                this.columnChart.data = [];
                return;
            }

            this.columnChart.data = yearSelected.months.map(item => [
                item.label || '',
                item.certificate || 0,
                item.consult || 0,
                item.donation || 0,
                item.escort || 0,
                item.maternity || 0
            ]);
        }, error => super.onError(error));
    }

    getMedicalCertificateByDayDashboard() {
        this.medicalCertificateByDayDashboardGQL.watch({input: this.searchDashboardInput}).valueChanges.subscribe(({data}) => {
            this.modelMedicalCertificateByDayDashboardDto = data?.medicalCertificateByDayDashboard as MedicalCertificateByDayDashboardDto;


            if (!this.modelMedicalCertificateByDayDashboardDto?.dates?.length) {
                this.lineChart.data = [];
                return;
            }

            this.lineChart.data = this.modelMedicalCertificateByDayDashboardDto.dates.map(item => [
                moment(item.date).format('DD/MM'),
                item.certificate || 0,
                item.consult || 0,
                item.donation || 0,
                item.escort || 0,
                item.maternity || 0
            ]);
        }, error => super.onError(error));
    }

    getMedicalCertificateTopCidDashboard() {
        this.medicalCertificateTopCidDashboardGQL.watch({input: this.searchDashboardInput}).valueChanges.subscribe(({data}) => {
            this.modelMedicalCertificateTopCidDashboardDto = data?.medicalCertificateTopCidDashboard as MedicalCertificateTopCidDashboardDto;

            if (!this.modelMedicalCertificateTopCidDashboardDto?.items?.length) {
                this.donutChart.data = [];
                return;
            }

            this.donutChart.data = this.modelMedicalCertificateTopCidDashboardDto.items.map(item => [
                item.cid || 'Não informado',
                item.total || 0
            ]);
        }, error => super.onError(error));
    }

}
